/**
 * Home try-on lines: quantity locked to 1 (faded UI; + shows banner message).
 * Legacy: optional cart-wide cap messaging via data-mirra-limited-by-cart (unused when one-per-frame is set).
 */
(function () {
  var CART_UPDATED_EVENT = 'action:cart:updateCart';

  function hideMirraTryOnBanner() {
    document.querySelectorAll('[data-mirra-tryon-banner]').forEach(function (el) {
      var bannerText = el.querySelector('[data-mirra-tryon-banner-text]');
      if (bannerText) bannerText.textContent = '';
      el.hidden = true;
      el.classList.remove('is-visible');
    });
  }

  function showMirraTryOnMessage(message, sourceInput) {
    if (!message) return;
    var fromDrawer =
      sourceInput &&
      sourceInput.closest &&
      sourceInput.closest('drawer-cart');
    if (fromDrawer) {
      var drawerBanner = document.querySelector(
        'cart-drawer-component [data-mirra-tryon-banner]'
      );
      var drawerBannerText = drawerBanner && drawerBanner.querySelector('[data-mirra-tryon-banner-text]');
      if (drawerBanner && drawerBannerText) {
        drawerBannerText.textContent = message;
        drawerBanner.hidden = false;
        drawerBanner.classList.add('is-visible');
        return;
      }
    }
    var fromCartPage =
      sourceInput &&
      sourceInput.closest &&
      sourceInput.closest('cart-page') &&
      !sourceInput.closest('drawer-cart');
    if (fromCartPage) {
      var cartPageBanner = document.querySelector(
        '[data-mirra-tryon-banner-location="cart-page"]'
      );
      var cartPageBannerText =
        cartPageBanner && cartPageBanner.querySelector('[data-mirra-tryon-banner-text]');
      if (cartPageBanner && cartPageBannerText) {
        cartPageBannerText.textContent = message;
        cartPageBanner.hidden = false;
        cartPageBanner.classList.add('is-visible');
        return;
      }
    }
    if (typeof HELPER_UTIL === 'undefined' || typeof _EVENT_HELPER === 'undefined') {
      window.alert(message);
      return;
    }
    HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.triggerToastMessage, document, {
      toastType: 'cart-drawer-errors',
      messageType: 'error',
      message: message,
    });
  }

  document.addEventListener(CART_UPDATED_EVENT, hideMirraTryOnBanner);

  function getTryOnQuantityInput(el) {
    var qs = el.closest && el.closest('quantity-selector');
    if (!qs) return null;
    var input = qs.querySelector('input[name="quantity"], input[name="updates[]"]');
    if (!input || input.getAttribute('data-mirra-try-on') !== 'true') return null;
    return input;
  }

  document.addEventListener(
    'click',
    function (e) {
      var inc = e.target.closest && e.target.closest('[increase-value]');
      if (!inc) return;
      var input = getTryOnQuantityInput(inc);
      if (!input) return;

      if (input.getAttribute('data-mirra-one-per-frame') === 'true') {
        var max = parseInt(input.getAttribute('max'), 10);
        var val = parseInt(input.value, 10) || 0;
        if (!Number.isFinite(max)) max = 1;
        if (val >= max) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          showMirraTryOnMessage(input.getAttribute('data-mirra-one-frame-message'), input);
        }
        return;
      }

      if (input.getAttribute('data-mirra-limited-by-cart') !== 'true') return;
      var max = parseInt(input.getAttribute('max'), 10);
      var val = parseInt(input.value, 10) || 0;
      if (!Number.isFinite(max) || val < max) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      showMirraTryOnMessage(input.getAttribute('data-mirra-max-message'), input);
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('input[name="quantity"], input[name="updates[]"]')) return;
      if (t.getAttribute('data-mirra-try-on') !== 'true') return;

      if (t.getAttribute('data-mirra-one-per-frame') === 'true') {
        var max = parseInt(t.getAttribute('max'), 10) || 1;
        var val = parseInt(t.value, 10) || 0;
        if (val > max) t.value = String(max);
        if (val < 1) t.value = '1';
        return;
      }

      var max = parseInt(t.getAttribute('max'), 10);
      var val = parseInt(t.value, 10) || 0;
      if (!Number.isFinite(max) || val <= max) return;
      t.value = String(max);
    },
    true
  );
})();
